export default "__VITE_ASSET__BdhW1g65__"